import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AbstractBasketComponent } from '@df/basket/abstract-basket.component';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { LocalBasket } from '../../basket/basket.decorator';
import { Product } from '../../catalog/product/product.decorator';
import { ProtectionPlansItemComponent } from './item/protection-plans-item.component';
@Component({
    selector: 'protection-plans',
    templateUrl: './protection-plans.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule,ProtectionPlansItemComponent]
})
export class ProtectionPlansComponent extends AbstractBasketComponent implements OnInit {
    productResource = inject(ProductResource);
    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.basket.subscribe(() => this.onBasketUpdate()));
        this.onBasketUpdate();
    }
    get productProtectionItems() {
        return this.productResource.getAllExisting(this.protectionPlansIds).filter(i => !this.basket.byProduct(i.id) && !i.isOutOfStock) as Product<IProductDataV3>[];
    }
    private get protectionPlansIds(): number[] {
        return (this.basket as LocalBasket).protectionPlansIds;
    }
    private onBasketUpdate(): void {
        if (this.protectionPlansIds.length) {
            this.productResource.loadAllIds(this.protectionPlansIds, 3, { safe: true }).finally(() => this.detectChanges());
        }
    }
    itemTrackFn(index: number, item: BasketItem): number {
        return item.id;
    }
}
